import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

export interface HealthHistoryLookupResponse {
    lookup_exists: boolean
}

export interface SubmitHealthHistoryReviewRequest {
    in_person_visit_order_id?: string
    visit_id?: string
}

export const healthHistoryApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getHealthHistoryLookupExists: builder.query<HealthHistoryLookupResponse, void>({
            query: () => apiEndpoints.healthHistory.lookupExists,
            providesTags: ['HealthHistory'],
        }),
        submitHealthHistoryReview: builder.mutation<void, SubmitHealthHistoryReviewRequest | void>({
            query: (body) => ({
                url: apiEndpoints.healthHistory.submitReview,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['HealthHistory', 'PreVisitRequirements'],
        }),
    }),
    overrideExisting: false,
})

export const { useGetHealthHistoryLookupExistsQuery, useSubmitHealthHistoryReviewMutation } = healthHistoryApi
